import { Button } from "@mui/material";
import React from "react";

const DiiaLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3288_10156)">
        <path
          d="M12 24C17.2584 24 20.1816 24 22.0908 22.0908C24 20.1816 24 17.2602 24 12C24 6.73982 24 3.81838 22.0908 1.90919C20.1816 0 17.2584 0 12 0C6.74158 0 3.81838 0 1.90919 1.90919C0 3.81838 0 6.74158 0 12C0 17.2584 0 20.1816 1.90919 22.0908C3.81838 24 6.74158 24 12 24Z"
          fill="black"
        />
        <path
          d="M16.5062 9.62695C15.5997 9.62695 14.9269 10.3267 14.9269 11.1902C14.9269 11.8952 15.4226 12.4452 16.0501 12.608L14.7637 14.5786H15.9652L17.0589 12.7447H17.8775V14.5786H18.8806V9.62695H16.5062ZM16.6441 11.9069C16.2316 11.9069 15.9761 11.5831 15.9761 11.2141C15.9761 10.845 16.2102 10.4934 16.6441 10.4934H17.8788V11.9069H16.6441Z"
          fill="white"
        />
        <path
          d="M11.0126 9.62695L10.6797 10.5435L12.0458 10.5356L11.2367 13.5028C11.0061 14.3679 11.9078 15.0216 12.6772 14.5128L14.4271 13.3257L13.9119 12.5684L12.1641 13.7791L13.3422 9.62695H11.0126Z"
          fill="white"
        />
        <path
          d="M12.8973 8.99099C13.2806 8.99099 13.5914 8.71099 13.5914 8.3656C13.5914 8.02022 13.2806 7.74023 12.8973 7.74023C12.5139 7.74023 12.2031 8.02022 12.2031 8.3656C12.2031 8.71099 12.5139 8.99099 12.8973 8.99099Z"
          fill="white"
        />
        <path
          d="M9.35622 13.6649V8.47656H5.50693V11.2457C5.50693 12.5487 5.12963 13.3542 4.90724 13.6627H4.45117V15.9258H5.4273V14.588H9.07684V15.9279H10.0525V13.6649H9.35622ZM6.47742 11.1887V9.39699H8.35528V13.6619H5.93125C6.15102 13.3024 6.47742 12.3877 6.47742 11.1887Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3288_10156">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DiiaButton = ({ onClick, label, className }: any) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      endIcon={<DiiaLogo />}
      sx={{
        minWidth: "auto",
        color: "#000",
        borderColor: "#000",
      }}
      className={className}
    >
      <div>{label}</div>
    </Button>
  );
};
